import { fieldCapabilityRegistry } from "@/app/field/fieldCapabilityRegistry";
import { getScreenById } from "@/app/screenRegistry";
import { bottomNavIdForScreen, iconKeyForScreen } from "@/app/nav/resolveBottomNav";
import { hasAnyPermission } from "@/shared/auth/permissions";
import type { BottomNavItem } from "@/shared/ui/layout/BottomNavigation";

/** Legacy Field bottom nav — emergency `VITE_NAV_SOURCE=legacy` only (W5). */
export function buildLegacyFieldBottomNav(
  permissions: readonly string[],
  roles?: readonly string[],
): BottomNavItem[] {
  const isNvSx = (roles ?? []).some(
    (r) => r.toUpperCase() === "ROLE_NV_SX" || r.toLowerCase() === "nv_sx",
  );
  return fieldCapabilityRegistry
    .filter(
      (c) =>
        c.status === "live" &&
        c.placement.includes("bottom-nav") &&
        (c.permissions.length === 0 ||
          (isNvSx &&
            (c.id === "field.pur.requisitions" || c.id === "field.batches")) ||
          hasAnyPermission(permissions, c.permissions)),
    )
    .map((c) => ({
      id: c.screenId
        ? bottomNavIdForScreen(c.screenId)
        : c.id.replace(/^field\./, "").replace(/\./g, "-"),
      label: c.label,
      route: c.path,
      icon: c.icon,
    }));
}

const EXE_LEGACY: { screenId: string; icon: string; label: string }[] = [
  { screenId: "SCR-EXE-HOME", icon: "home", label: "Trang chủ" },
  { screenId: "SCR-EXE-APPROVALS", icon: "check-square", label: "Duyệt" },
  { screenId: "SCR-EXE-ALERTS", icon: "alert-triangle", label: "Cảnh báo" },
  { screenId: "SCR-EXE-REPORTS", icon: "bar-chart-3", label: "Báo cáo" },
  { screenId: "SCR-EXE-ACCOUNT", icon: "user", label: "Tài khoản" },
];

/** Legacy EXE bottom nav filtered by screenRegistry permissions. */
export function buildLegacyExeBottomNav(
  permissions: readonly string[],
): BottomNavItem[] {
  const items: BottomNavItem[] = [];
  for (const row of EXE_LEGACY) {
    const screen = getScreenById(row.screenId);
    if (!screen) continue;
    if (
      screen.permissions.length > 0 &&
      !hasAnyPermission(permissions, screen.permissions)
    ) {
      continue;
    }
    items.push({
      id: bottomNavIdForScreen(row.screenId),
      label: row.label,
      route: screen.path,
      icon: row.icon || iconKeyForScreen(row.screenId),
    });
  }
  return items;
}
